<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>验证码记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-input
          placeholder="请输入邮箱或电话号码"
          clearable
          v-model="account"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button
          type="primary"
          @click="handleSearch"
        >搜索</el-button>
      </div>
      <el-table :data="dataList">
        <el-table-column width="100px" prop="account" label="账号"></el-table-column>
        <el-table-column prop="title" label="标题"/>
        <el-table-column prop="content" label="内容"/>
        <el-table-column label="发送时间">
          <template slot-scope="scope">
            {{scope.row.createTime | moment}}
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import api from './api'
export default {
  name: 'User',
  data() {
    return {
      account: '',
      dataList:[]
    };
  },
  computed: {
  },
  methods: {
    getList(){
      api.smsEmailSendRecordList({account:this.account}).then(res=>{
        console.log(res)
        this.dataList = res.data;
      })
    },
    handleSearch(){
      this.$confirm('敏感信息后台会记录查看日志，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        this.getList();
      });
      
    }
  },
  created() {
  }
};
</script>

<style lang="less" scoped>
</style>
